<template>
    <button class="square-button" :style="{aspectRatio: (aspectRationChange) ? 4 : 2}" @click="$emit('click')" :disabled="isDisabled" :hidden="isHidden">
        <div class="button-content">
            <i :class="icon"></i> <span>
                <slot></slot>
            </span>
        </div>
    </button>
</template>

<script>
export default {
    props: {
        icon: {
            type: String, // Font Awesome icon class (e.g., "fa-solid fa-trash-can")
            required: true,
        },
        isDisabled: {
            type: Boolean,
            required: true,
        },
        isHidden: {
            type: Boolean,
            required: true,
        },
        aspectRationChange: {
            type: Boolean,
            default: false,
            required: false
        },
    },

    emits: ['click']
};
</script>

<style scoped>
.square-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: none;
    border-radius: 0% !important;
    background-color: #f0f0f0;
    color: #00A0C1;
    cursor: pointer;
    font-size: 1rem;
    transition: background-color 0.3s ease, color 0.3s ease;
    /* aspect-ratio: 2; */
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
}

.square-button:hover:enabled {
    background-color: #e6e6e6;
    color: #00A0C1;
}

.square-button:disabled {
    background-color: #D3D3D3;
}

.square-button:active:enabled {
    background-color: #ddd;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.15);
}

.square-button--small {
    font-size: 0.8rem;
    padding: 5px;
}

.square-button--medium {
    font-size: 1rem;
    padding: 10px;
}

.square-button--large {
    font-size: 1.2rem;
    padding: 15px;
}

.square-button--icon {
    padding: 0;
}

.square-button--icon img {
    max-width: 80%;
    max-height: 80%;
}

.button-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
}

.button-content span {
    margin-top: 5px;
    font-size: 0.8rem;
    text-align: center;
}

.button-content img {
    max-width: 24px;
    max-height: 24px;
}
</style>